import { BaseModel, toDayjs } from './baseModel';
import { Event } from './event';
import { Transform, Type } from 'class-transformer';
import * as dayjs from 'dayjs';

export enum ViewersValues {
  'OWN' = 'admin.event.reviews.configuration.own',
  'ASSIGNER' = 'admin.event.reviews.configuration.assigner',
  'ALL' = 'admin.event.reviews.configuration.all'
}

export enum ViewersWithoutOwnValues {
  'ASSIGNER' = 'admin.event.reviews.configuration.assigner',
  'ALL' = 'admin.event.reviews.configuration.all'
}

export enum AnonymityValues {
  'NO' = 'admin.event.reviews.configuration.no',
  'REVIEW' = 'admin.event.reviews.configuration.review'
}

export class EventReviewConfiguration extends BaseModel {
  event: Event;

  doubleBlind: boolean;
  anonymousReview: boolean;
  similarityVerification: boolean;
  docolocUsername: string;
  docolocPassword: string;

  authorsCanView: boolean;
  authorsCanViewScores: boolean;
  @Transform(value => isNaN(value) ? value : Object.keys(ViewersValues)[value])
  tpcCanView: string;
  @Transform(value => isNaN(value) ? value : Object.keys(ViewersWithoutOwnValues)[value])
  tpcViewReviewIdentity: string;

  copyReviewAssigner: boolean;
  numberOfReviewsRequired: number;
  numberOfReviewsForTpcMember: number;
  journalDaysForReview: number;

  @Transform(toDayjs)
  conferenceDateDue: dayjs.Dayjs;

  @Transform(toDayjs)
  reminderStartDate: dayjs.Dayjs;

  daysBetweenReminders: number;

  blockReview: boolean;
  tpcListAllPapers: boolean;
  showOnlyCompletedReviewToTpc: boolean;
  paperRankingToTpc: boolean;

  spanLimitA: number;
  spanLimitB: number;

  tpcDelegate: boolean;

  /**
   * Read-only, calculado pelo BACKEND para o usuário da requisição: ele pode
   * delegar revisões neste evento? Combina a config `tpcDelegate` com o papel
   * de quem pergunta (chair/super passam direto; os demais precisam ser
   * membros do comitê).
   *
   * Não é config — é resposta sobre o usuário atual, e por isso NÃO entra no
   * formulário de configuração do chair (o backend a ignora na escrita).
   *
   * `undefined`/`null` = "não sei" (payload antigo ou sem contexto): a UI
   * trata como permitido. Falha ABERTA de propósito — a garantia está no
   * servidor, e esconder o botão por engano seria pior que mostrá-lo à toa.
   */
  canDelegate?: boolean;

  tpcAssignToExternal: boolean;
  tpcBidClaimPaper: boolean;
  claimPendingSubmissions: boolean;

  discussionPeriodEnable: boolean;
  @Transform(toDayjs)
  discussionPeriodStart: dayjs.Dayjs;
  @Transform(toDayjs)
  discussionPeriodEnd: dayjs.Dayjs;

  public get discussionPeriodIsOpen(): boolean {
    return dayjs() > this.discussionPeriodStart;
  }

  public get discussionPeriodIsClosed(): boolean {
    return dayjs() > this.discussionPeriodEnd;
  }

  bidPeriodEnable: boolean;
  @Transform(toDayjs)
  bidPeriodStart: dayjs.Dayjs;
  @Transform(toDayjs)
  bidPeriodEnd: dayjs.Dayjs;

  public get bidPeriodIsOpen(): boolean {
    return dayjs() < this.bidPeriodEnd && dayjs() >= this.bidPeriodStart;
  }

  public get bidPeriodIsEditable(): boolean {
    const now = dayjs();
    return this.bidPeriodEnable && now > this.bidPeriodStart && now < this.bidPeriodEnd;
  }

  rebuttalPeriodEnable: boolean;
  @Transform(toDayjs)
  rebuttalPeriodStart: dayjs.Dayjs;
  @Transform(toDayjs)
  rebuttalPeriodEnd: dayjs.Dayjs;


  public get rebuttalPeriodIsOpen(): boolean {
    return dayjs() > this.rebuttalPeriodStart;
  }

  public get rebuttalPeriodIsClosed(): boolean {
    return dayjs() > this.rebuttalPeriodEnd;
  }

  constructor(
  ) { super(); }
}
